import axios from "axios.js";
import axiosKeyInstance from "axiosKeyCloak";
import Cookies from "js-cookie";
import { showSnackbar } from "./UiAction";
import Swal from "sweetalert2";

// Defines all states values
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GET_REQUESTED_SUBJECT = "GET_REQUESTED_SUBJECT";
export const LOGIN_IMPERSONATE = "LOGIN_IMPERSONATE";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const GET_OVER_SPEED_SOCKET = "GET_OVER_SPEED_SOCKET";
export const GET_STUDENT_ATTENDANCE_DATA = "GET_STUDENT_ATTENDANCE_DATA";
export const GET_MAINTENANCE_STATUS = "GET_MAINTENANCE_STATUS";
export const RESET_DASHBOARD_DATA = 'RESET_DASHBOARD_DATA';
export const GET_DRIVER_ATTENDANCE_DATA = "GET_DRIVER_ATTENDANCE_DATA";
export const GET_TRANSPORTATION_ALLOWANCE_DATA = "GET_TRANSPORTATION_ALLOWANCE_DATA";
export const GET_USER_TOKEN = "GET_USER_TOKEN";

export const getDashboardData = (data, year) => (dispatch) => {
  // call dashboard all data get api
  axios.post("/dashboard", data, {
    headers: {
      academic_year: year,
    }
  }).then((res) => {
    dispatch({
      type: GET_DASHBOARD_DATA,
      payload: res.data,
    });
  });
};

export const resetDashboardDataData = () => ({
  type: RESET_DASHBOARD_DATA,
});

export const getRequestedSubject = (data) => (dispatch) => {
  // update setting api
  axios.post("/user/id", data).then((response) => {
    dispatch({
      type: GET_REQUESTED_SUBJECT,
      payload: response.data,
    });

    if (response.data.data !== null) {

      axios.get("/user/token").then((res) => {
        dispatch({
          type: GET_USER_TOKEN,
          payload: res.data,
        });

        const params = new URLSearchParams();
        params.append(
          "grant_type",
          "urn:ietf:params:oauth:grant-type:token-exchange"
        );
        params.append("client_id", "react-app");
        params.append("client_secret", "f64197d3-9adb-442a-b8c7-dded39f993c1");
        // params.append("subject_token", Cookies.get("accessToken"));
        // params.append("subject_token", localStorage.getItem("accessToken"));
        params.append("subject_token", res.data.data);
        params.append("requested_subject", response.data.data);
        dispatch(loginImpersonate(params));
        setTimeout(() => dispatch(loginImpersonate(params)), 1000);
      });
    } else {
      Swal.fire({
        text: "તમે દાખલ કરેલ કોડ ખોટો છે કૃપા કરીને માન્ય કોડ દાખલ કરો.",
        icon: "info",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });
    }

    // });
  })
    .catch((error) => {
      Swal.fire({
        text: "તમે દાખલ કરેલ કોડ ખોટો છે કૃપા કરીને માન્ય કોડ દાખલ કરો.",
        icon: "info",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });
    });

};

export const loginImpersonate = (data) => (dispatch) => {

  // update setting api
  axiosKeyInstance
    .post("/realms/users/protocol/openid-connect/token", data)
    .then((response) => {
      if (response.status !== 403 || 400) {
        dispatch({
          type: LOGIN_IMPERSONATE,
          payload: response.data,
        });
        Cookies.set("accessToken", response.data.access_token, {
          secure: true, httpOnly: true
        });
        localStorage.setItem("accessToken", response.data.access_token);
        localStorage.setItem("Impersonate_status", true);
        //setTimeout(() => localStorage.setItem("Impersonate_status", true), 10);
        window.location.reload();
      } else {
        Swal.fire({
          text: "તમે દાખલ કરેલ કોડ ખોટો છે કૃપા કરીને માન્ય કોડ દાખલ કરો.",
          icon: "info",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        });
      }
      // });
    })
    .catch((error) => {
      Swal.fire({
        text: "તમે દાખલ કરેલ કોડ ખોટો છે કૃપા કરીને માન્ય કોડ દાખલ કરો.",
        icon: "info",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });
    });
};

export const resetChangePassword = (data) => (dispatch) => {
  // reset password
  axios
    .post("/login/change/password", data)
    .then((response) => {
      dispatch(showSnackbar(response.data.message, "top", "success"));
      dispatch({
        type: RESET_PASSWORD,
        payload: response.data,
      });
      localStorage.setItem("password_status", false);
      window.location.reload();
    })
    .catch((error) => {
      dispatch(showSnackbar(error.message, "top", "error"));
    });
};

export const getOverSpeedData = (data) => (dispatch) => {
  dispatch({
    type: GET_OVER_SPEED_SOCKET,
    payload: data,
  });
};

export const getStudentAttendanceData = (data, type, id, year) => (dispatch) => {
  // call student attendace chart data get api
  axios
    .post("/dashboard/attendance/chart", data, {
      headers: {
        filter_type: type,
        filter_code: id,
        academic_year: year,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_STUDENT_ATTENDANCE_DATA,
        payload: res.data,
      });
    });
};

export const getMaintenanceStatus = () => (dispatch) => {
  axios.get("/maintenance/status").then((res) => {
    dispatch({
      type: GET_MAINTENANCE_STATUS,
      payload: res.data,
    });
  });
};

export const getDriverAttendanceData = (data, type, id, year) => (dispatch) => {
  // call driver attendace chart data get api
  axios
    .post("/dashboard/attendance/driver/chart", data, {
      headers: {
        filter_type: type,
        filter_code: id,
        academic_year: year,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_DRIVER_ATTENDANCE_DATA,
        payload: res.data,
      });
    });
};

export const getTransportationAllowanceChartData = (month, year) => (dispatch) => {
  axios
    .get(`/dashboard/transportation-allowance/chart?month=${month}`, {
      headers: {
        academic_year: year,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_TRANSPORTATION_ALLOWANCE_DATA,
        payload: res.data,
      });
    });
};

export const getUserToken = () => (dispatch) => {
  axios.get("/user/token").then((res) => {
    dispatch({
      type: GET_USER_TOKEN,
      payload: res.data,
    });
  });
};